import { useEffect, useState } from "react";
import Chat from "./components/Chat";
import "./App.css";
import 'react-loading-skeleton/dist/skeleton.css';

function App() {
  const [isKeyAvailable, setIsKeyAvailable] = useState(true);
  const [apiKey, setApiKey] = useState('');
  const [chatImage, setChatImage] = useState({ src: '', width: 140, height: 140 });
  const [widgetKey, setWidgetKey] = useState('');
  const [notificationMessage, setNotificationMessage] = useState({ title: '', body: '', delay: '' });
  const [chatBotFeatures, setChatBotFeatures] = useState({ isChatBotOpen: false, isTermsConditionHide: false });

  useEffect(() => {
    // api-key
    const scriptElementApiKey = document.querySelector("script[data-embed]") || document.querySelector("script[data-curatu-api-key]");
    // widget key
    const scriptElementWidgetKey = document.querySelector("script[data-website]") || document.querySelector("script[data-curatu-widget-key]");
    // Image
    const scriptElementImage = document.querySelector("script[data-curatu-image]");
    // Image Width
    const scriptElementImageWidth = document.querySelector("script[data-curatu-image-width]");
    // Image Height
    const scriptElementImageHeight = document.querySelector("script[data-curatu-image-height]");
    //Notification Message Title
    const scriptElementNotificationMessageTitle = document.querySelector("script[data-curatu-notification-message-title]");
    //Notification Message body
    const scriptElementNotificationMessageBody = document.querySelector("script[data-curatu-notification-message-body]");
    //Notification Message delay
    const scriptElementNotificationMessageDelay = document.querySelector("script[data-curatu-notification-message-delay]");
    const scriptElementIsChatWindowOpen = document.querySelector("script[data-curatu-is-chat-window-open]");
    const scriptElementIsTermsConditionHide = document.querySelector("script[data-curatu-is-terms-condition-hide]");
    const scriptSkipCache = document.querySelector("script[data-curatu-skip-x]");


    // To Do: Remove hardcoded API key from here
    // To Do: Remove hardcoded Brain Id from here
    const apiKey = scriptElementApiKey?.getAttribute("data-embed")
      || scriptElementApiKey?.getAttribute("data-curatu-api-key")
      || process.env.REACT_APP_API_KEY;
    const widgetKey = scriptElementWidgetKey?.getAttribute("data-website")
      || scriptElementWidgetKey?.getAttribute("data-curatu-widget-key")
      || process.env.REACT_APP_WIDGET_KEY;
    const chatbotImage = scriptElementImage?.getAttribute("data-curatu-image")
      || `${process.env.REACT_APP_ENV_URL}/assets/chat-icon-light.svg`;
    const chatbotImageWidth = scriptElementImageWidth?.getAttribute("data-curatu-image-width").replace(/\D/g, '')
      || 80;
    const chatbotImageHeight = scriptElementImageHeight?.getAttribute("data-curatu-image-height").replace(/\D/g, '')
      || 80;
    const notificationMessageTitle = scriptElementNotificationMessageTitle?.getAttribute("data-curatu-notification-message-title")
      || '';
    const notificationMessageBody = scriptElementNotificationMessageBody?.getAttribute("data-curatu-notification-message-body")
      || '';
    const notificationMessageDelay = scriptElementNotificationMessageDelay?.getAttribute("data-curatu-notification-message-delay")
      || 15000;
    const isChatBotOpenState = scriptElementIsChatWindowOpen?.getAttribute("data-curatu-is-chat-window-open")
      ?? false;
    const isTermsConditionHide = scriptElementIsTermsConditionHide?.getAttribute("data-curatu-is-terms-condition-hide")
      ?? false;
    const shouldSkipCache = scriptSkipCache?.getAttribute("data-curatu-skip-x") 
      ?? false;
    // For Local development
    // const apiKey = scriptElementApiKey?.getAttribute("data-curatu-api-key")
    //   || 'mMJ1b3b_A84XBDFBQ57kr9XPnrmECk9KRsgjkC4s-wU';
    // const chatbotImage = scriptElementImage?.getAttribute("data-curatu-image")
    //   || 'https://static.curatu.ai/assets/chat-icon.png';
    // const currentUserId = scriptElementUserId?.getAttribute("data-curatu-user-id")
    //   || '';
    setApiKey(apiKey);
    setWidgetKey(widgetKey)
    setChatImage({ src: chatbotImage, width: chatbotImageWidth, height: chatbotImageHeight });
    setNotificationMessage({ title: notificationMessageTitle, body: notificationMessageBody, delay: notificationMessageDelay })
    setChatBotFeatures({ isChatBotOpen: isChatBotOpenState, isTermsConditionHide, shouldSkipCache })

    setIsKeyAvailable(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isKeyAvailable && (
        <div className="App">
          <Chat apiKey={apiKey} chatImage={chatImage} widgetKey={widgetKey} notificationMessage={notificationMessage} chatBotFeatures={chatBotFeatures} />
        </div>
      )}
    </>
  );
}

export default App;
